import {ISegmentationFormStoreService} from "@/modules/Segmentation/services/ISegmentationFormStoreService";
import {inject, injectable} from "tsyringe";
import {IHttpService} from "frontend-core";
import {AxiosResponse} from "axios";
import {ProductCode, ProductCodeEnum} from "@/modules/Segmentation/models/ProductCode";

@injectable()
export class SegmentationFormStoreService implements ISegmentationFormStoreService {
    readonly productCodes: ProductCode[] = [
        new ProductCode(ProductCodeEnum.osago, "osago"),
        new ProductCode(ProductCodeEnum.osaga, "osaga"),
    ];
    readonly carModels: string[] = [];
    readonly carTypes: string[] = [];
    readonly clientType: string[] = [
        "Юр. лицо",
        "ИП",
        "Физ. лицо"
    ];
    readonly carPurposeTypes: string[] = [];
    readonly kbmValuesVariants: (string | number)[] = [
        "Не выбрано", 3.92, 2.94, 2.25, 1.76, 1.17, 1, 0.91, 0.83, 0.78, 0.74, 0.68, 0.63, 0.57, 0.52, 0.46,
    ];
    readonly okved: string[] = [];

    constructor(
        @inject("IHttpService")
        private readonly httpService: IHttpService,
    ) {
    }

    async fillCarModels(): Promise<void> {
        if (this.carModels.length === 0) {
            await this.httpService.apiLegacy.get("/lib/auto.json")
                .then((result: AxiosResponse<{
                    [key: string]: ICarMarkDto
                }>) => {
                    Object.keys(result.data).forEach((markKey: string) => {
                        const mark: ICarMarkDto = result.data[String(markKey)];

                        this.carModels.push(...Object.keys(mark).map(i => `${markKey} ${i}`));
                    });
                });
        }
    }

    async fillCarPurposes(): Promise<void> {
        if (this.carPurposeTypes.length === 0) {
            await this.httpService.apiLegacy.get("/lib/auto_purpose.json")
                .then((res: AxiosResponse<Array<{ name: string }>>) => {
                    res.data.forEach(i => this.carPurposeTypes.push(i.name));
                });
        }
    }

    async fillCarTypes(): Promise<void> {
        if (this.carTypes.length === 0) {
            await this.httpService.apiLegacy.get("/lib/auto_category.json")
                .then((res: AxiosResponse<Array<{ description: string }>>) => {
                    Object.values(res.data).forEach(i => this.carTypes.push(i.description));
                });
        }
    }
}

export interface ICarMarkDto {
    [key: string]: ICarModelDto;
}

export interface ICarModelDto {
    Category: "A" | "B" | "C" | "D";
    Engine: string;
    Foreign: boolean;
    MaxWeight: string;
}
